import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import PacmanLoader from "react-spinners/PacmanLoader";


const commonLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <Loader
      type="ThreeDots"
      color="#dc143c"
      height={100}
      width={100}
      timeout={3000}
    />
  </div>
);

const pacmanLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <PacmanLoader
      size="50"
      color="#dc143c"
      margin="2"
      css={{ width: "260px !important", height: "130px !important" }}
    />
  </div>
);


const loaderFunctions = { commonLoader, pacmanLoader };

export default loaderFunctions;
